var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDepotDel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#3B66B0;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M26.2,22.7H11v18.6H6.4V16.5L25,9.1l18.6,7.5v4.1c1.8,0.9,3.3,2,4.7,3.4V13.4L25,4L1.7,13.4V46h14V27.3h6.7 C23.4,25.5,24.7,24,26.2,22.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21.6,41.3H18V46h4.7v-2.5C22.2,42.8,21.9,42.1,21.6,41.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "41,28.9 36.5,33.5 32,29 30.2,30.8 34.7,35.3 30.2,39.8 32,41.5 36.5,37 41,41.5 42.8,39.7  38.3,35.2 42.8,30.7  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M45.4,26.3c-1.1-1.1-2.5-2-4-2.7s-3.2-1-4.9-1s-3.4,0.3-4.9,1s-2.9,1.6-4,2.7s-2,2.5-2.7,4s-1,3.2-1,4.9 s0.3,3.4,1,4.9s1.6,2.9,2.7,4s2.5,2,4,2.7c1.5,0.7,3.2,1,4.9,1s3.4-0.3,4.9-1s2.9-1.6,4-2.7c1.1-1.1,2-2.5,2.7-4s1-3.2,1-4.9 s-0.3-3.4-1-4.9C47.4,28.8,46.5,27.4,45.4,26.3z M43.6,42.4c-1.9,1.9-4.3,2.9-7.1,2.9s-5.2-1-7.1-2.9s-2.9-4.3-2.9-7.1 s1-5.2,2.9-7.1s4.3-2.9,7.1-2.9s5.2,1,7.1,2.9c1.9,1.9,2.9,4.3,2.9,7.1S45.5,40.5,43.6,42.4z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDepotDel);
export default __webpack_public_path__ + "static/media/depot-del.bf8a536b3d46306a6b3862027320e673.svg";
export { ForwardRef as ReactComponent };